var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 97,
    viewBox: "0 0 88 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.8672 55.582L22.2797 22.0005C21.8778 20.4288 22.1167 18.7618 22.9439 17.3662C23.771 15.9706 25.1187 14.9608 26.6904 14.5589C28.2621 14.157 29.9291 14.3959 31.3247 15.2231C32.7203 16.0502 33.7301 17.3979 34.132 18.9696L41.7092 48.6004M41.204 46.625L39.1835 38.7235C38.7815 37.1517 39.0205 35.4847 39.8476 34.0892C40.6748 32.6936 42.0225 31.6838 43.5942 31.2819C45.1659 30.88 46.8329 31.1189 48.2285 31.946C49.624 32.7732 50.6339 34.1209 51.0358 35.6926L53.5615 45.5695M52.0461 39.6434C51.6441 38.0716 51.883 36.4046 52.7102 35.0091C53.5374 33.6135 54.8851 32.6037 56.4568 32.2018C58.0285 31.7999 59.6955 32.0388 61.0911 32.8659C62.4866 33.6931 63.4964 35.0408 63.8984 36.6125L65.4138 42.5386",
    stroke: "#D6AF66",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9085 40.5632C64.5066 38.9914 64.7455 37.3244 65.5727 35.9289C66.3998 34.5333 67.7475 33.5235 69.3192 33.1216C70.8909 32.7197 72.5579 32.9586 73.9535 33.7857C75.3491 34.6129 76.3589 35.9606 76.7608 37.5323L81.3071 55.3107C82.9148 61.5976 81.9592 68.2656 78.6505 73.8479C75.3418 79.4301 69.9511 83.4694 63.6642 85.0771L55.7627 87.0977L56.5845 86.8875C52.6589 87.8921 48.5453 87.906 44.613 86.9279C40.6808 85.9499 37.053 84.0105 34.0554 81.284L32.978 80.2968C31.2618 78.7209 25.0054 72.2842 14.2088 60.9866C13.1081 59.835 12.5 58.2994 12.514 56.7065C12.528 55.1135 13.1629 53.5888 14.2836 52.4567C15.4784 51.252 17.0407 50.4802 18.7234 50.2633C20.4062 50.0465 22.1132 50.397 23.5743 51.2594L30.867 55.5819M8.91182 19.1051L3.95077 16.1646M9.00222 35.9185L5.05145 36.9288M44.4687 10.0125L47.4092 5.05145M51.4504 20.8545L55.4011 19.8442",
    stroke: "#D6AF66",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHand);
export default __webpack_public_path__ + "static/media/hand.2b20b17879aebdaa617589f8cb78dcb8.svg";
export { ForwardRef as ReactComponent };